









'use strict';

var Animated=require('./Animated');

function isAnimated(obj){
return obj instanceof Animated;
}

module.exports=isAnimated;


/*****************
 ** WEBPACK FOOTER
 ** ./~/animated/lib/isAnimated.js
 ** module id = 457
 ** module chunks = 0
 **/